import { useEffect, useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getGlobalRenderingInfoApi } from '../api/globalapi';
import { useUserContext } from '../contexts/UserContext';
import { apiGetOrganizationBalance, apiGetRenderingPriceInfo } from '../helpers/api';
import { imagePaymentFormPopupActions } from '../redux/slicers/imagePaymentFormPopupSlicer';
import { isMattressBuilderPage } from '../components/admin/curator/ProductBuilderComponents/commonHelper';
import { isCuratorPage } from '../helpers/urlHelper';
import { selectUnityLoaded } from '../redux/slicers/admin/curatorSlicer';

export const useBaseAPICalls = () => {
  const dispatch = useDispatch();
  const { currentUser, isGuestUser } = useUserContext();
  const unityLoaded = useSelector(selectUnityLoaded);

  const setRenderingInfo = async () => {
    let orgBalance = {};
    const data = await apiGetRenderingPriceInfo();
    if (!isGuestUser()) {
      const balance = await apiGetOrganizationBalance();
      if (typeof balance?.effective_balance === 'number') {
        orgBalance = { ...balance };
      }
    }
    if (!data) return;
    const info = {
      ...data,
      premium: data.premium ? Number(data.premium) : 0,
      standard: data.standard ? Number(data.standard) : 0,
      uhd_price: data.uhd_price ? Number(data.uhd_price) : 0,
      expired_subscription_rate: data.expired_subscription_rate
        ? Number(data.expired_subscription_rate)
        : 0,
      ...orgBalance,
    };
    dispatch(imagePaymentFormPopupActions.setRenderingPriceInfo(info));
  };

  useEffect(() => {
    if (isCuratorPage() && unityLoaded) {
      dispatch(getGlobalRenderingInfoApi()); // calling this api when the unity is loaded successfully & if the page is curator to keep the curator loading fast
    }
  }, [unityLoaded]);

  useLayoutEffect(() => {
    if (!currentUser?.organization) return;
    if (!isCuratorPage()) dispatch(getGlobalRenderingInfoApi());

    if (isMattressBuilderPage()) return;
    setRenderingInfo(); // no need to call the rendering info on mattress builder curator page
  }, [currentUser?.organization]);

  return;
};
